// extracted by mini-css-extract-plugin
export var connectionButton = "_ag-1";
export var rightPanel = "_ag-3";
export var stepDescription = "_ag-2";
export var stepIcon = "_ag-0";